import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import {
  getExperiments,
  createExperiment,
  updateExperiment,
} from "../api/experiments"

export const useExperiments = () =>
  useQuery({
    queryKey: ["experiments"],
    queryFn: getExperiments,
    select: (data) => data?.data || [],
  })

export const useCreateExperiment = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createExperiment,
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: ["experiments"] })
      toast.success(response?.message || "Experiment created")
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to create experiment"
      toast.error(message)
    },
  })
}

export const useUpdateExperiment = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateExperiment,
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: ["experiments"] })
      toast.success(response?.message || "Experiment updated")
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update experiment"
      toast.error(message)
    },
  })
}
